"use client"

import { FormBody, FormProps } from "@dtc/site-blocks"
import { useState } from "react"

/**
 * Client part of the storefront Form block. Receives only serializable
 * FormProps (the server wrapper in site-form.tsx strips the puck render
 * props, which carry functions and cannot cross the RSC boundary), posts
 * the fields to the backend lead endpoint and surfaces success or error.
 */
export default function SiteFormClient(
  props: FormProps & { tenantId?: string }
) {
  const [submitting, setSubmitting] = useState(false)
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle")

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setSubmitting(true)
    setStatus("idle")

    const form = e.currentTarget
    const data = new FormData(form)
    const fields: Record<string, string> = {}
    for (const field of props.fields ?? []) {
      const value = data.get(field.label)
      if (typeof value === "string" && value.trim()) {
        fields[field.label] = value
      }
    }

    try {
      const backendUrl =
        process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL ?? "http://localhost:9000"
      const res = await fetch(`${backendUrl}/storefront/site-leads`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          ...(props.tenantId ? { "x-tenant-id": props.tenantId } : {}),
        },
        body: JSON.stringify({
          fields,
          page_path: window.location.pathname,
        }),
      })

      if (!res.ok) {
        throw new Error(`status ${res.status}`)
      }

      form.reset()
      setStatus("success")
    } catch {
      setStatus("error")
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <FormBody
      {...props}
      onSubmit={handleSubmit}
      submitting={submitting}
      status={status}
    />
  )
}
